"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseLicenseDto = instanceOfNurseLicenseDto;
exports.NurseLicenseDtoFromJSON = NurseLicenseDtoFromJSON;
exports.NurseLicenseDtoFromJSONTyped = NurseLicenseDtoFromJSONTyped;
exports.NurseLicenseDtoToJSON = NurseLicenseDtoToJSON;
exports.NurseLicenseDtoToJSONTyped = NurseLicenseDtoToJSONTyped;
const State_1 = require("./State");
const LicenseStatus_1 = require("./LicenseStatus");
const NurseNursysTransactionDto_1 = require("./NurseNursysTransactionDto");
const CompactStatus_1 = require("./CompactStatus");
/**
 * Check if a given object implements the NurseLicenseDto interface.
 */
function instanceOfNurseLicenseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined)
        return false;
    if (!('jurisdiction' in value) || value['jurisdiction'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('statusMessage' in value) || value['statusMessage'] === undefined)
        return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined)
        return false;
    if (!('statusLastUpdatedAt' in value) || value['statusLastUpdatedAt'] === undefined)
        return false;
    if (!('compactStatus' in value) || value['compactStatus'] === undefined)
        return false;
    if (!('licenseNursysTransactions' in value) || value['licenseNursysTransactions'] === undefined)
        return false;
    return true;
}
function NurseLicenseDtoFromJSON(json) {
    return NurseLicenseDtoFromJSONTyped(json, false);
}
function NurseLicenseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'nurseProfileId': json['nurseProfileId'],
        'licenseNumber': json['licenseNumber'],
        'jurisdiction': (0, State_1.StateFromJSON)(json['jurisdiction']),
        'licenseType': json['licenseType'],
        'status': (0, LicenseStatus_1.LicenseStatusFromJSON)(json['status']),
        'statusMessage': json['statusMessage'],
        'expirationDate': (json['expirationDate'] == null ? null : new Date(json['expirationDate'])),
        'statusLastUpdatedAt': (json['statusLastUpdatedAt'] == null ? null : new Date(json['statusLastUpdatedAt'])),
        'compactStatus': (0, CompactStatus_1.CompactStatusFromJSON)(json['compactStatus']),
        'licenseNursysTransactions': (json['licenseNursysTransactions'] == null ? null : json['licenseNursysTransactions'].map(NurseNursysTransactionDto_1.NurseNursysTransactionDtoFromJSON)),
    };
}
function NurseLicenseDtoToJSON(json) {
    return NurseLicenseDtoToJSONTyped(json, false);
}
function NurseLicenseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'nurseProfileId': value['nurseProfileId'],
        'licenseNumber': value['licenseNumber'],
        'jurisdiction': (0, State_1.StateToJSON)(value['jurisdiction']),
        'licenseType': value['licenseType'],
        'status': (0, LicenseStatus_1.LicenseStatusToJSON)(value['status']),
        'statusMessage': value['statusMessage'],
        'expirationDate': (value['expirationDate'] == null ? null : value['expirationDate'].toISOString().substring(0, 10)),
        'statusLastUpdatedAt': (value['statusLastUpdatedAt'] == null ? null : value['statusLastUpdatedAt'].toISOString().substring(0, 10)),
        'compactStatus': (0, CompactStatus_1.CompactStatusToJSON)(value['compactStatus']),
        'licenseNursysTransactions': (value['licenseNursysTransactions'] == null ? null : value['licenseNursysTransactions'].map(NurseNursysTransactionDto_1.NurseNursysTransactionDtoToJSON)),
    };
}
//# sourceMappingURL=NurseLicenseDto.js.map